try{self['workbox:sw:6.5.1']&&_()}catch(e){}// eslint-disable-line